import React from 'react';
import styles from './styles.module.sass';

export default ({ id }) => (
  <div id={id} className={styles.anchor}/>
);